import { CMDHsPokerDrawByIndex } from "./CMDHsPokerDrawByIndex"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScPokerShow implements ICommand
{

	public GameID : number = 0;
	public PokerData : CMDHsPokerDrawByIndex;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.GameID = ba.readInt53();
		this.PokerData = new CMDHsPokerDrawByIndex();
		this.PokerData.fromBytes(ba);
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.GameID);
		let tempBuf1 = this.PokerData.toBytes().toBuffer();
		ba.appendBuf(tempBuf1)

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScPokerShow();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'PokerData(CMDHsPokerDrawByIndex)='+this.PokerData+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30022;
	}

	public getCmdName() : string
	{
		return 'ScPokerShow';
	}

}
